import { useState, useEffect, useRef } from 'react'
import { Modal } from 'bootstrap'
import { Link } from "react-router-dom";
import axios from "axios";
import FestivalHeadline from "./FestivalHeadline";
import { withTranslation, Trans } from 'react-i18next';
import config from '../../config';


function FestivalGrid(props) {


  const [session, setSession] = useState(0);
  const [currentLang, setCurrentLang] = useState(props.i18n.language);
  const [loading, setLoading] = useState(true);
  const [contents, setContents] = useState(null);
  const [images, setImages] = useState(null);



  useEffect(() => {
   setCurrentLang(props.i18n.language);


   if(!session) {
     const result = axios(
       config.backendBase + 'session/token',
     );

     setSession(result.data);

     var lang = '';

     if(props.i18n.language != 'de') {
       lang = props.i18n.language + '/';
     }

     axios({
       method: 'GET',
       url: config.backendBase+lang+'jsonapi/node/festival?include=field_image&sort=created',
       headers: {
         'Content-Type': 'json',
         'X-CSRF-Token': session,
       }
     })
       .then(res => {
         ////console.log(res);
         setContents(res.data.data);
         setImages(res.data.included);
         setLoading(false);
       })
       .catch(err => {
         ////console.log(err);
         setLoading(false);
       });
   }

 }, [props.i18n.language]);




  return (
    <>

    {loading &&
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }

    {!loading &&
      <>


          {contents.map(function(content, idx){

            //if(artist.attributes.field_date)

            var odd = idx % 2 == 0;

             return (
              <div className="container-fluid container-list" key={idx}>
                  <FestivalHeadline headline={content.attributes.title} />
                 <div className='row'>
                   <div className="col-md-12">
                     <div className="container">
                       <div className="row">
                         <div className="col-md-6">
                           <img src={config.backendBase + images.find(x => x.id === content.relationships.field_image.data.id).attributes.uri.url} className="img-fluid" />
                         </div>
                         <div className="col-md-6">
                           <h3>{content.attributes.title}</h3>
                           <div dangerouslySetInnerHTML={{ __html: content.attributes.body.value }} />
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             )
           })}
       </>
    }
    </>
  );
}

export default withTranslation()(FestivalGrid);
